import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from "./authentication.service";

@Injectable({ providedIn: 'root' })
export class CanUpdatePermissionsGuard  {

  private canUpdatePermissions: boolean;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    ) {
    this.canUpdatePermissions = this.authenticationService.organizationData.canUpdatePermissions;
    this.authenticationService.organizationDataUpdatedEvent.subscribe(() => {
      this.canUpdatePermissions = this.authenticationService.organizationData.canUpdatePermissions;
    });

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.canUpdatePermissions) {
      this.router.navigate(['/home'], {queryParams: {returnUrl: state.url}});
      return false;
    }

    return true;
  }
}
